import React, { useContext } from "react";
import Layout from "../../components/Layout/Layout";
import cx from "classnames";
import { QuoteGroupContext } from "../../providers/RootContextProvider";
import ProductSelectPageContentMultiProduct from "./ProductSelectPageContent/ProductSelectPageContentMultiProduct";
import { Redirect } from "react-router-dom";
import ProductSelectPageContentMultiProductEdit from "./ProductSelectPageContent/ProductSelectPageContentMultiProductEdit";
import ProductType, {
    ClientProductTypesList,
    isClientProductType
} from "../../../common/interfaces/enums/ProductType";

interface IProductsSelectPageProps {
    isEditable?: boolean;
}

export const ProductsSelectPage: React.FC<IProductsSelectPageProps> = ({
    isEditable
}) => {
    const { selectors } = useContext(QuoteGroupContext);

    const search = new URLSearchParams(location.search);

    const getProductURLParam = (): ProductType[] => {
        const product =
            search.has("product") &&
            (search.getAll("product") as ProductType[]).filter(isClientProductType);

        return product;
    };

    const getInitialSelectedProducts = (): ProductType[] => {
        if (search.has("product")) return getProductURLParam();

        return ClientProductTypesList.filter((product) =>
            selectors.hasQuoteSettingsForProduct(product)
        );
    };

    const initialProducts = getInitialSelectedProducts();

    if (selectors.isNewSession()) {
        const paramBuilder = new URLSearchParams();
        initialProducts.forEach((s) => {
            paramBuilder.append("product", s);
        });
        return <Redirect to={`/family?${paramBuilder.toString()}`} />;
    }

    return (
        <Layout
            hideMenu={!selectors.hasCreatedQuote()}
            progressBarCurrentStage={"build"}>
            <div className={cx("layout-products-select-pg")}>
                {isEditable ? (
                    <ProductSelectPageContentMultiProductEdit />
                ) : (
                        <ProductSelectPageContentMultiProduct
                            initialProductsSelected={initialProducts}
                        />
                )}
            </div>
        </Layout>
    );
};
